var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('jx-header'),_c('jx-main'),_c('jx-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }